import { SmartComponent } from "smart-component-js";

class AdvancedSearchBarComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;

    // Selezione input e bottone
    this.input = this.element.querySelector("#advanced-search-input");
    this.button = this.element.querySelector("#advanced-search-button");

    this.init();
  }

  init() {
    // Funzionalità input di ricerca
    this.input.addEventListener("input", () => this.toggleButtonColor());
    this.toggleButtonColor();

    // Gestione del click sul bottone
    // this.button.addEventListener("click", () => {
    //   const query = this.input.value.trim();
    //   if (query !== "") {
    //     console.log("Ricerca per:", query);
    //     // Emissione di un evento personalizzato con il valore della ricerca
    //     this.emit("search", query);
    //   }
    // });
  }

  toggleButtonColor() {
    if (this.input.value.trim() !== "") {
      this.button.classList.add("active");
    } else this.button.classList.remove("active");
  }
}

export default AdvancedSearchBarComponent;
